import store from "../store";

export const hasRole = (...args) => {
  const user = store.getters.getUser;
  const joker = user.role.includes("super-admin");
  const roles = user.role;
  const verifiedRoles = args.filter((curr) => roles.includes(curr));
  return joker || !!verifiedRoles.length;
};

export const hasPermission = (...args) => {
  const user = store.getters.getUser;
  const joker = user.role.includes("super-admin");
  const permissions = user.permissions;
  const verifiedPermissions = args.filter((curr) => permissions.includes(curr));
  return joker || !!verifiedPermissions.length;
};
